/** The references object of all modules needed for components initialization */
var references = {
    'storelocator' : require('_core_ext/pages/storelocator/storelocator'),
};

module.exports = {
    'references' : references
};
